import { AxiosInstance } from 'axios';

const getConfigFullPath = (configName: string): string => {
  return `/api/configmodule/entity/${configName}`;
};

export const configApi = (http: AxiosInstance | null) => {
  if (!http) {
    return null;
  }

  return {
    getConfigByName: (configName: string) => {
      return http.get<any>(getConfigFullPath(configName));
    },
  };
};
